import { createSignal } from 'solid-js'

export const [pushOn, setPushOn] = createSignal(
  typeof Notification !== 'undefined' && Notification?.permission === 'granted' && localStorage.push_on === 'on'
)

export const PUSH_OK = 'ok'
export const PUSH_UNSUPPORTED = 'unsupported'
export const PUSH_IOS_NOT_INSTALLED = 'ios-not-installed'
export const PUSH_DENIED = 'denied'
export const PUSH_FAILED = 'failed'

export function isIos() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
}

export function urlBase64ToUint8Array(base64) {
  const padding = '='.repeat((4 - base64.length % 4) % 4)
  const binary = atob((base64 + padding).replace(/-/g, '+').replace(/_/g, '/'))
  const arr = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i)
  return arr
}

async function getVapidKey() {
  const r = await fetch('/api/push/vapid-key').then(r => r.json())
  return r.key ?? r.data?.key
}

export async function togglePush() {
  if (pushOn()) return unsubscribePush()
  return subscribePush()
}

export async function subscribePush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return PUSH_UNSUPPORTED
  if (typeof Notification === 'undefined') return PUSH_UNSUPPORTED
  if (isIos() && !isStandalone()) return PUSH_IOS_NOT_INSTALLED
  const permission = Notification.permission === 'granted'
    ? 'granted'
    : await Notification.requestPermission()
  if (permission !== 'granted') {
    localStorage.push_on = 'off'
    setPushOn(false)
    return PUSH_DENIED
  }
  const reg = await navigator.serviceWorker.ready
  let key = await getVapidKey()
  if (!key) return PUSH_FAILED
  try {
    const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(key) })
    const ok = await fetch('/api/push/subscribe', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(sub)
    }).then(r => r.ok)
    if (ok) { localStorage.push_on = 'on'; setPushOn(true) }
    return ok ? PUSH_OK : PUSH_FAILED
  } catch (e) {
    console.warn(e)
    localStorage.push_on = 'off'
    setPushOn(false)
    return PUSH_FAILED
  }
}

export async function unsubscribePush() {
  if (!('serviceWorker' in navigator)) return PUSH_UNSUPPORTED
  const reg = await navigator.serviceWorker.ready
  const sub = await reg.pushManager.getSubscription()
  if (sub) {
    await sub.unsubscribe()
    await fetch('/api/push/subscribe', {
      method: 'DELETE', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(sub)
    })
  }
  localStorage.push_on = 'off'
  setPushOn(false)
  return PUSH_OK
}
